import React, { Component } from "react";
import "react-table/react-table.css";
import "../../tables/reactTable.css";
import ReactTableComponent from "../../tables/ReactTable";

import editicon from "../../../../src/Components/assets/edit.png";
import swal from "sweetalert";
import DateFnsUtils from "@date-io/date-fns";
import NextArrow from "../../../../src/Components/assets/upAerrow.png";
import Autocomplete from "@material-ui/lab/Autocomplete";

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from "@material-ui/pickers";
import {
  campaignContactsTabList2,
  campaignContactsTabSelectList2,
  campaignContactsExport,
  triggerStatusMutation
} from "../../../Queries";

import SearchIcon from "../../assets/search.png";
import { TextField, Button, MenuItem, Select } from "@material-ui/core";
import "../CampaignTables.css";
import "../CampaignTabs.css";
import "./CampaignContactsTab.css";
import "./CampaignTriggersTab.css";

import ConvertTo from "./ConvertTo";
import { contacts, Profileid, plannedDate } from "../campaignQueries";
import { fetchMethod } from "../../../FetchMethod";
import ContactDetails from "./ContactDetails.js";
import { Drawer } from "@material-ui/core";
import Photo from "../../assets/photo.png";
const moment = require("moment");

class CampaignContactsTab extends Component {

  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      search: "",
      search2: "All",
      loading: false,
      limit: 0,
      offset: 0,
      searchFlag: false,
      clickToSearch: false,
      campaignContacts: [],
      campaignContactsTableList: [],
      totalCount: 0,
      selectedDate: new Date(),
      fileName: "Contacts",
      Currentstage: [],
      invitationSent: [],
      anchorEl: null,
      show: "",
      openDetails: false,
      columnFilter: "",
      shortfilter: false,
      getData: [],
      getCampaignId: null,
      getCampaignId2: null,
      getCustomer: [],
      contactStatus: null,
      campaignStatus: null,
      contactId: null,
      Row: "",
      row2: null,
      ContactDetailsWorkflow: [],
      ContactDetailsMessages: [],
      campStatus: ["All", "Live", "Pause", "Completed"],
      defaultCampStatus: "All",
      contStatus: ["All", "Suspect", "Prospect", "Opportunity"],
      defaultContStatus: "All",
      selected: {},
      selectAll: 0,
      selectedArray: [],
      campaignContactAllSelectedList: [],
      profileid: undefined,
      salesforcetoken: null,
      hubspottoken: null,
      isSearching: false,
      campaignContactsExportData: [],
      clientY: null,
      clientX: null,
      triggertype: "",
      startDate: null,
      updateStatus: {},
      options2: [],
      anchorEl: false,
      confil: 0
    };
  }
  componentDidMount() {
    this.setState({
      options2: [
        { id: "Shared a post", name: "Shared a post" },
        { id: "viewed your profile", name: "viewed your profile" },
        { id: "started a new position", name: "started a new position" },
        { id: "liked your post", name: "liked your post" }
      ]
    });
    
    this.setState({ show: false }, () =>
      this.props.detailEdit(this.state.show)
    );
    this.Profile();
  }

  ExportData = () => {
    const filter = this.filter();
    this.setState({
      filter: this.filter()
    });

    fetchMethod(campaignContactsExport, filter).then(res => res.json());
  };
  ExportData2 = () => {
    this.setState({
      confil: 1
    });
    const filter = this.filter();
    fetchMethod(campaignContactsExport, filter).then(res => res.json());
  };

  Profile = () => {
    fetchMethod(Profileid(this.props.campaignId))
      .then(res => res.json())
      .then(res => {
        this.setState({
          profileid:
            res.data.Campaigns.customercredentialsIbfk1rel
              .Customerlinkedinprofiles[0].id,
          hubspottoken:
            res.data.Campaigns.customercredentialsIbfk1rel
              .Customerlinkedinprofiles[0].hubspottoken,
          salesforcetoken:
            res.data.Campaigns.customercredentialsIbfk1rel
              .Customerlinkedinprofiles[0].salesforcetoken
        });
      })
      .catch(e => console.log(e));
  };

  emptySelectedArray = () => {
    this.setState({ selectedArray: [], selectAll: false, selected: {} });
  };

  handleDateChange = date => {
    this.setState({
      selectedDate: date
    });
  };

  SetLimit = limit => {
    this.setState({
      limit
    });
  };

  SetOffset = offset => {
    this.setState({ offset });
  };

  setContactsListData = response => {
    let data = response.data.allTriggernotifications.Triggernotifications;

    this.setState(
      {
        campaignContacts: data,
        totalCount: response.data.allTriggernotifications.totalCount
      },
      () => this.fetchSequence(this.state.campaignContacts)
    );
  };

  onSearchClick2 = () => {
 

    const updateStatus = {
      where: { id: this.state.row2 },
      data: {
        followup: this.state.startDate
      }
    };

    swal({
      title: "Are you sure want to convert?",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willConvert => {
      if (willConvert) {
        fetchMethod(triggerStatusMutation, updateStatus)
          .then(response => {
            return response.json();
          })
          .then(res => {
            this.handleClose();
            if (res.data.TriggernotificationUpsertWithWhere) {
              swal("Successfully updated", { icon: "success" }).then(() => {
                this.child.current.searchFetch(
                  this.state.limit,
                  this.state.offset
                );
              });
            } else swal("Error", { icon: "error" });
          })

          .catch(err => {
            console.log(err);
            swal("Error", { icon: "error" });
          });
      }
    });
  };
  handleClose = () => {
    this.setState({ anchorEl: false });
  };
  onSearchClick = () => {
    if (this.state.searchFlag === true) {
      this.setState({ clickToSearch: true }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData();
      });
    } else {
      this.setState({ clickToSearch: false }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData();
      });
    }
  };

  onSearchClick3 = () => {
    if (this.state.searchFlag === true) {
      this.setState({ clickToSearch: true }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData2();
      });
    } else {
      this.setState({ clickToSearch: false }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData2();
      });
    }
  };

  debounce = (debounceTimer, func, delay) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(func, delay);
    return debounceTimer;
  };
  debounceTimer = null;
  handleSearchChange = event => {
    this.setState({
      search: event.target.value,
      confil: 0,
      searchFlag: true,
      isSearching: true
    });
    this.debounceTimer = this.debounce(
      this.debounceTimer,
      () => {
        this.onSearchClick();
        this.setState({ isSearching: false });
      },
      200
    );
  };

  handleSearchChange2 = event => {
    if (event.target.outerText === "Shared a post") {
      this.setState({
        options2: [
          { id: "All", name: "All" },
          { id: "viewed your profile", name: "viewed your profile" },
          { id: "started a new position", name: "started a new position" },
          { id: "liked your post", name: "liked your post" }
        ]
      });
    }
    if (event.target.outerText === "All") {
      this.setState({
        options2: [
          { id: "Shared a post", name: "Shared a post" },
          { id: "viewed your profile", name: "viewed your profile" },
          { id: "started a new position", name: "started a new position" },
          { id: "liked your post", name: "liked your post" }
        ]
      });
    }
    if (event.target.outerText === "viewed your profile") {
      this.setState({
        options2: [
          { id: "All", name: "All" },
          { id: "Shared a post", name: "Shared a post" },
          { id: "started a new position", name: "started a new position" },
          { id: "liked your post", name: "liked your post" }
        ]
      });
    }
    if (event.target.outerText === "started a new position") {
      this.setState({
        options2: [
          { id: "All", name: "All" },
          { id: "Shared a post", name: "Shared a post" },
          { id: "viewed your profile", name: "viewed your profile" },
          { id: "liked your post", name: "liked your post" }
        ]
      });
    }
    if (event.target.outerText === "liked your post") {
      this.setState({
        options2: [
          { id: "All", name: "All" },
          { id: "Shared a post", name: "Shared a post" },
          { id: "viewed your profile", name: "viewed your profile" },
          { id: "started a new position", name: "started a new position" }
        ]
      });
    }

    this.setState({
      search2: event.target.outerText,

      confil: 1,

      searchFlag: true,
      isSearching: true
    });
    this.debounceTimer = this.debounce(
      this.debounceTimer,
      () => {
        this.onSearchClick3();
        this.setState({ isSearching: false });
      },
      200
    );
  };

  handleStatusChange = (row, updateStatus) => event => {
    updateStatus = {
      where: { id: row.original.id },
      data: {
        triggerstatus: event.target.value,
        lastactiondate: new Date().toISOString().slice(0, 10)
      }
    };

    swal({
      title: "Are you sure want to convert?",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willConvert => {
      if (willConvert) {
        fetchMethod(triggerStatusMutation, updateStatus)
          .then(response => {
            return response.json();
          })
          .then(res => {
            if (res.data.TriggernotificationUpsertWithWhere) {
              swal("Successfully updated", { icon: "success" }).then(() => {
                this.child.current.searchFetch(
                  this.state.limit,
                  this.state.offset
                );
              });
            } else swal("Error", { icon: "error" });
          })

          .catch(err => {
            console.log(err);
            swal("Error", { icon: "error" });
          });
      }
    });
  };

  handleStatusChange2 = (row, updateStatus, date) => event => {
    updateStatus = {
      where: { id: row.original.id },
      data: {
        followup: this.formatDate3(event)
      }
    };

    swal({
      title: "Are you sure want to convert?",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willConvert => {
      if (willConvert) {
        fetchMethod(triggerStatusMutation, updateStatus)
          .then(response => {
            return response.json();
          })
          .then(res => {
            if (res.data.TriggernotificationUpsertWithWhere) {
              swal("Successfully updated", { icon: "success" }).then(() => {
                this.child.current.searchFetch(
                  this.state.limit,
                  this.state.offset
                );
              });
            } else swal("Error", { icon: "error" });
          })

          .catch(err => {
            console.log(err);
            swal("Error", { icon: "error" });
          });
      }
    });
  };

  onTableRowClick = rowInfo => {
    this.setState({ Row: rowInfo.original.contactid });
  };
  fetchContactDrawerDetails = (side, open, row) => event => {
    this.setState({ getData: [] });
    fetchMethod(contacts(row.contactid))
      .then(res => res.json())
      .then(res => {
        res.data.allContacts !== undefined
          ? this.setState({
              ContactDetailsWorkflow:
                res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                  ? res.data.allContacts.Contacts[0].Contactworkflowhistoryfk
                      .Contactworkflowhistories
                  : "",
              ContactDetailsMessages:
                res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                  ? res.data.allContacts.Contacts[0].Contactmessagesfk
                      .Contactmessages
                  : "",
              getData:
                res.data.allContacts !== undefined &&
                res.data.allContacts !== null
                  ? res.data.allContacts.Contacts[0]
                  : "",
              getCampaignId:
                res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                  ? res.data.allContacts.Contacts[0].campaignid
                  : "",
              getCampaignId2:
                res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                  ? res.data.allContacts.Contacts[0].campaignid
                  : "",

              getCustomer:
                res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null &&
                res.data.allContacts.Contacts[0].Campaigns.Campaigns.length > 0
                  ? res.data.allContacts.Contacts[0].Campaigns.Campaigns[0]
                      .Customers.Customers[0]
                  : "",
              contactStatus:
                res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                  ? res.data.allContacts.Contacts[0].contactstatus
                  : "",
              campaignStatus:
                res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                  ? res.data.allContacts.Contacts[0].campaignstatus
                  : "",
              contactId:
                res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                  ? res.data.allContacts.Contacts[0].id
                  : ""
            })
          : this.setState({ loading: true });
      })
      .catch(e => console.log(e));
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ ...this.state, [side]: open });
  };

  closeDetails = () => {
    this.setState({
      openDetails: false,
      getCampaignId: [],
      getCustomer: [],
      getData: [],
      contactStatus: null,
      campaignStatus: null
    });
  };

  clearFilters = () => {
    this.setState(
      {
        search: "",
        search2: "All",
        searchFlag: false,
        clickToSearch: false,
        limit: 50,
        offset: 50
      },
      () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData();
      }
    );
  };

  fetchRefresh = response => {
    this.fetchMessage(response);
  };
  fetchMessage = response => {
    fetchMethod(contacts(response))
      .then(res => res.json())
      .then(res => {
        res.data.allContacts !== undefined
          ? this.setState({
              ContactDetailsMessages:
                res.data.allTriggernotifications.Triggernotifications[0] !==
                  undefined &&
                res.data.allTriggernotifications.Triggernotifications[0] !==
                  null
                  ? res.data.allTriggernotifications.Triggernotifications[0]
                      .Contactmessagesfk.Contactmessages
                  : ""
            })
          : this.setState({ loading: true });
      })
      .catch(e => console.log(e));
  };
  onSearchKeyDown = event => {
    return event.key === "Enter" ? this.onSearchClick() : "";
  };
  handleStartDate = date => {
    this.setState(
      {
        startDate: this.formatDate3(date)
      },
      () => {
        this.onSearchClick2();
      }
    );
  };

  formatDate3 = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(date);
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }
    return;
  };
  formatDate = date => {

    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }
    return;
  };

  formatDate2 = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date = `${mm}/${dd}/${yyyy}`;
      return date;
    }
    return;
  };

  fetchRefresh1 = response => {
    this.fetchName(response);
  };
  fetchName = response => {
    fetchMethod(contacts(response))
      .then(res => res.json())
      .then(res => {
        res.data.allContacts !== undefined
          ? this.setState({
              getData:
                res.data.allContacts !== undefined &&
                res.data.allContacts !== null
                  ? res.data.allTriggernotifications.Triggernotifications[0]
                  : ""
            })
          : this.setState({ loading: true });
      })
      .catch(e => console.log(e));
  };

  gettingAllDataFromQuery = () => {
    const filter = this.filter();
    fetchMethod(campaignContactsTabSelectList2, filter)
      .then(response => {
        return response.json();
      })
      .then(responseAsJson => {
        let allselectedIds = [];
        responseAsJson.data.allTriggernotifications.Triggernotifications.map(
          i => {
            allselectedIds.push({ id: i.id });
          }
        );
        this.setState(
          {
            campaignContactAllSelectedList: allselectedIds
          },
          () => {
            let selectedArr = [];
            let consolidateArray = [];
            this.state.campaignContactAllSelectedList.map(item => {
              consolidateArray[item.id] = true;
              selectedArr.push({ id: item.id });
            });
            this.setState({
              selectAll: true,
              selected: consolidateArray,
              selectedArray: selectedArr
            });
          }
        );
      })
      .catch(e => {
        console.log(e);
        this.setState({ loading: true });
      });
  };

  onRowSelected = sarray => {
    if (sarray.length === this.state.totalCount) {
      this.setState({ selectAll: true });
    } else {
      this.setState({ selectAll: false });
    }
  };

  toggleRowNew = (id, rowInfo) => {
    const newSelected = Object.assign({}, this.state.selected);
    newSelected[id] = !this.state.selected[id];
    this.setState({
      selected: newSelected
    });
    const { selectedArray } = this.state;
    let arr = selectedArray.filter(val => val.id !== id);
    if (!arr.length) {
      this.setState(
        {
          selectedArray: []
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    }
    if (arr.length === selectedArray.length) {
      this.setState(
        {
          selectedArray: [...selectedArray, rowInfo]
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    } else {
      this.setState(
        {
          selectedArray: arr
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    }
  };

  toggleSelectAllRow = isChecked => {
    if (isChecked) {
      this.gettingAllDataFromQuery();
    } else {
      this.setState({
        selectAll: false,
        selectedArray: [],
        selected: {}
      });
    }
  };

  NameFilter = () => {
    this.setState({ columnFilter: "name asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  NameFilter1 = () => {
    this.setState({ columnFilter: "name desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  CompanyFilter = () => {
    this.setState({ columnFilter: "organization asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  CompanyFilter1 = () => {
    this.setState(
      { columnFilter: "organization desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  PositionFilter = () => {
    this.setState({ columnFilter: "designation asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  PositionFilter1 = () => {
    this.setState(
      { columnFilter: "designation desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  LocationFilter = () => {
    this.setState({ columnFilter: "location asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  LocationFilter1 = () => {
    this.setState({ columnFilter: "location desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  notificationdateFilter = () => {
    this.setState({ columnFilter: "notificationdate asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  notificationdateFilter1 = () => {
    this.setState(
      { columnFilter: "notificationdate desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  triggertypeFilter = () => {
    this.setState(
      { columnFilter: "triggertype asc", shortfilter: true },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  triggertypeFilter1 = () => {
    this.setState(
      { columnFilter: "triggertype desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  triggerstatusFilter = () => {
    this.setState(
      { columnFilter: "triggerstatus asc", shortfilter: true },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  triggerstatusFilter1 = () => {
    this.setState(
      { columnFilter: "triggerstatus desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
    lastactiondateFilter = () => {
    this.setState(
      { columnFilter: "lastactiondate asc", shortfilter: true },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  lastactiondateFilter1 = () => {
    this.setState(
      { columnFilter: "lastactiondate desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  //followup
      followupFilter = () => {
    this.setState(
      { columnFilter: "followup asc", shortfilter: true },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  followupFilter1 = () => {
    this.setState(
      { columnFilter: "followup desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  filter = () => {
    const search = this.state.clickToSearch ? this.state.search : "";
    const like = `%${search}%`;  // "%" + `${search}` + "%";
    const search2 = this.state.clickToSearch ? this.state.search2 : "";
    const like2 = `%${search2}%`;   //"%" + `${search2}` + "%";
    let filter = {};

    if (this.state.confil === 0) {
      
      filter = {
        where: {
          campaignid: this.props.campaignId,
          active: 1,

          order: this.state.columnFilter,
          and: [
            {
              or: [
                { organization: { like: like, options: "i" } },
                { name: { like: like, options: "i" } },
                { location: { like: like, options: "i" } },
                { triggertype: { like: like, options: "i" } }
              ]
            }
          ]
        }
      };
    } else {
      filter = {
        where: {
          campaignid: this.props.campaignId,
          active: 1,
          and: [
            {
              or: [
                { triggerdata: { like: like2, options: "i" } },
                { triggertype: { like: like2, options: "i" } }
              ]
            }
          ]
        }
      };
    }

    return filter;
  };

  fetchSequence = async responsee => {
    let index = 0;
    responsee.map(async response => {
      if (
        response !== undefined &&
        response.currentStage !== undefined &&
        response.currentStage.Contactworkflowhistories !== undefined
      ) {
        let l = response.currentStage.Contactworkflowhistories.length - 1;
        let sequence = response.currentStage.Contactworkflowhistories[l];
        if (
          sequence &&
          sequence.contactworkflowhistoryIbfk2rel &&
          sequence.contactworkflowhistoryIbfk2rel.Campaignsteps[0] &&
          sequence.contactworkflowhistoryIbfk2rel &&
          sequence.contactworkflowhistoryIbfk2rel.Campaignsteps[0]
        ) {
          const plannedDateFilter = {
            where: {
              campaignid:
                sequence.contactworkflowhistoryIbfk2rel.Campaignsteps[0]
                  .campaignid,
              active: 1,
              sequence:
                sequence.contactworkflowhistoryIbfk2rel.Campaignsteps[0]
                  .sequence + 1
            }
          };

          response.currentStage.Contactworkflowhistories[
            l
          ].nextStep = undefined;
          await fetchMethod(plannedDate, plannedDateFilter)
            .then(res => res.json())
            .then(res => {
              if (
                res &&
                res.data &&
                res.data.allCampaignsteps &&
                res.data.allCampaignsteps.Campaignsteps.length > 0 &&
                res.data.allCampaignsteps.Campaignsteps[0]
              ) {
                let daysDelay =
                  res.data.allCampaignsteps.Campaignsteps[0].daysdelay;
                let NextStepName =
                  res.data.allCampaignsteps.Campaignsteps[0].stepname;
                if (
                  NextStepName === "SEND_THANKS_MESSAGE" &&
                  response.connectedon
                ) {
                  var Connectedon = "";
                  if (
                    response.thanksmsgdate === "" ||
                    response.thanksmsgdate == null
                  ) {
                    Connectedon = response.connectedon.split("/");
                  } else {
                    Connectedon = response.thanksmsgdate.split("/");
                  }
                  Connectedon =
                    Connectedon[2] +
                    "/" +
                    Connectedon[1] +
                    "/" +
                    Connectedon[0];
                  let date = new Date(Connectedon);
                  let someDate = new Date(date);

                  let addDate = 0;
                  if (
                    response.thanksmsgdate === "" ||
                    response.thanksmsgdate == null
                  ) {
                    addDate = daysDelay;
                  } else {
                    addDate = 0;
                  }

                  let dd1 = someDate.setDate(someDate.getDate() + addDate);

                  let oldDate = new Date(dd1);

                  let todayDate = new Date();

                  let diffTime = todayDate - oldDate;

                  let diffDays = diffTime / (1000 * 60 * 60 * 24);

                  if (diffDays >= 0) {
                    let Planndate = new Date(todayDate);

                    let dd = Planndate.getDate(dd1);
                    let mm = Planndate.getMonth() + 1;
                    let yyyy = Planndate.getFullYear();
                    if (dd < 10) {
                      dd = "0" + dd;
                    }
                    if (mm < 10) {
                      mm = "0" + mm;
                    }

                    Planndate = `${dd}/${mm}/${yyyy}`;

                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      "Send Thanks Message " + Planndate;
                  } else if (diffDays < 0) {
                    let Planndate = new Date(oldDate);

                    let dd = Planndate.getDate(dd1);
                    let mm = Planndate.getMonth() + 1;
                    let yyyy = Planndate.getFullYear();
                    if (dd < 10) {
                      dd = "0" + dd;
                    }
                    if (mm < 10) {
                      mm = "0" + mm;
                    }

                    Planndate = `${dd}/${mm}/${yyyy}`;
                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      "Send Thanks Message " + Planndate;
                  } else {
                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      "Send Thanks Message " + date;
                  }
                } else if (NextStepName !== "SEND_THANKS_MESSAGE") {
                  var current_date = "";
                  var addDay = 0;
                  if (sequence.nextstep == null || sequence.nextstep === "") {
                    current_date = sequence.executedon;
                    addDay = daysDelay;
                  } else {
                    current_date = sequence.nextstep;
                    addDay = 0;
                  }

                  var someDate = new Date(current_date);

                  current_date = someDate.setDate(someDate.getDate() + addDay);
                  let oldDate = new Date(current_date).getTime();
                  let todayDate = new Date().getTime();

                  let difference = todayDate - oldDate;
                  let diffDays = difference / (1000 * 3600 * 24);

                  if (diffDays >= 0) {
                    let date = moment(todayDate)
                      .toDate();
                    let current_date1 = new Date(date);
                    let utc =
                      current_date1.getTime() +
                      current_date1.getTimezoneOffset() * 60000;
                    let offset_time = new Date(utc + 3600000 * 5.5);
                    let planDate = moment(offset_time).format("DD/MM/YYYY");
                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      NextStepName === "SEND_INVITE"
                        ? "Send Invite"
                        : NextStepName === "FOLLOW"
                        ? "Follow"
                        : NextStepName === "VISIT"
                        ? "Visit"
                        : "Send Message" + " " + planDate;
                  } else if (diffDays < 0) {
                    let date = moment(oldDate)
                      .toDate();

                    let current_date1 = new Date(date);
                    let utc =
                      current_date1.getTime() +
                      current_date1.getTimezoneOffset() * 60000;
                    let offset_time = new Date(utc + 3600000 * 5.5);
                    let planDate = moment(offset_time).format("DD/MM/YYYY");

                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      NextStepName === "SEND_INVITE"
                        ? "Send Invite "
                        : NextStepName === "FOLLOW"
                        ? "Follow "
                        : NextStepName === "VISIT"
                        ? "Visit "
                        : "Send Message " + planDate;
                  } else {
                    let date = moment(current_date)
                      .add(daysDelay, "days")
                      .toDate();
                    let current_date1 = new Date(date);
                    var utc =
                      current_date1.getTime() +
                      current_date1.getTimezoneOffset() * 60000;
                    var offset_time = new Date(utc + 3600000 * 5.5);
                    var date1 = moment(offset_time).format("DD/MM/YYYY");

                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      NextStepName === "SEND_INVITE"
                        ? "Send Invite "
                        : NextStepName === "FOLLOW"
                        ? "Follow "
                        : NextStepName === "VISIT"
                        ? "Visit "
                        : "Send Message " + date1;
                  }
                }
              }
            })
            .catch(e => console.log(e));
        }
      }
      index++;
      if (index === responsee.length && this.state.totalCount !== 0) {
        this.setState({ campaignContacts: responsee });
      }
    });
  };

  showEngagedToPopup = row => e => {
    this.setState({
      selectedEngagedRow: {
        ...row,

        anchorEl: e.currentTarget
      },

      clientY: e.clientY,
      clientX: e.clientX
    });
    this.ExportData();
  };

  onCloseEngagedPopup = () => {
    this.setState({ selectedEngagedRow: null });
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: false });
  };

  render() {
    const open = Boolean(this.state.anchorEl);
   // const id = open ? "simple-popover" : undefined;
    const campaignContacts = [...this.state.campaignContacts];
    
    const { selectedEngagedRow } = this.state;
    const campaignContactsExportData = [
      ...this.state.campaignContactsExportData
    ];
    const CampaignContactsListHeaders = [
      {
       
      },

      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.NameFilter
                  : this.NameFilter1
              }
            >
              Name
            </div>
          );
        },
        accessor: "Name",
         width: 130,
        Cell: row => (
          <div
            style={{ cursor: "pointer", color: "#2BADDD" }}
            onClick={this.fetchContactDrawerDetails(
              "openDetails",
              true,
              row.original
            )}
          >
            {row.original.name}
          </div>
        )
      },

      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.CompanyFilter
                  : this.CompanyFilter1
              }
            >
              Company
            </div>
          );
        },
        accessor: "organization",
         width: 130,
      },
      {
        Header: " Position ",
        accessor: "position"
      },

      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.LocationFilter
                  : this.LocationFilter1
              }
            >
              Location
            </div>
          );
        },
        accessor: "location"
      },
      {
        Header: " Trigger ",
        accessor: "triggerdata"
      },
      {
                Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.triggertypeFilter
                  : this.triggertypeFilter1
              }
            >
              Trigger Type
            </div>
          );
        },
        accessor: "triggertype",
         width: 130,
      },


      {
            Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.notificationdateFilter
                  : this.notificationdateFilter1
              }
            >
              Date
            </div>
          );
        },
        accessor: "notificationdate"
      },


      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
           
            >
              URL
            </div>
          );
        },
        accessor: "url",
        Cell: row => (
          <div>
            <a href={row.original.url} title={row.original.url} target="_blank">
              {row.original.url}
            </a>
          </div>
        )
      },

      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
                  onClick={
                this.state.shortfilter !== true
                  ? this.triggerstatusFilter
                  : this.triggerstatusFilter1
              }
            >              
              Status
            </div>
          );
        },
        accessor: "triggerstatus",
        Cell: row => (
          <div>
            <Select
             
              value={row.original.triggerstatus}
              displayEmpty
              onChange={this.handleStatusChange(row)}
            >
              <MenuItem value="Actioned">Actioned</MenuItem>
              <MenuItem value="Not relevant">Not relevant</MenuItem>
              <MenuItem value="Revisit">Revisit</MenuItem>
            </Select>
          </div>
        )
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
                    onClick={
                this.state.shortfilter !== true
                  ? this.lastactiondateFilter
                  : this.lastactiondateFilter1
              }
            >
              Last Action Date
            </div>
          );
        },
        accessor: "lastactiondate",
             width: 150,
        Cell: row => <div>{this.formatDate(row.original.lastactiondate)}</div>
      },

      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
                      onClick={
                this.state.shortfilter !== true
                  ? this.followupFilter
                  : this.followupFilter1
              }
            >
              Follow Up
            </div>
          );
        },
        accessor: "followup",
 width: 130,
        Cell: row => {
          return (
            <div
              className="iconButton"
              style={{
                color: row.original.followup2 === 1 ? "#FFBF00" : "red"
              }}

          
            >
              {row.original.followup}

              <span className="EditIcon">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    format="dd/MM/yyyy"
                    value={this.state.startDate}
               
                    onChange={this.handleStatusChange2(row)}
               
                    keyboardIcon={
                      <img src={editicon} alt="" style={{ width: "17px" }} />
                    }
                    InputProps={{
                      disableUnderline: true
                    }}
                    helperText={""}
                  />
                </MuiPickersUtilsProvider>

             
              </span>
            </div>
          );
        }
      },
      {}
    ];

    campaignContacts.map(list => {
      if (
        list.lastresponse !== undefined &&
        list.lastresponse !== null &&
        list.lastresponse
      ) {
        list.LR = this.formatDate(list.lastresponse.split("T")[0]);
      
      }

      if (
        list.followup !== undefined &&
        list.followup !== null &&
        list.followup !== "" &&
        list.followup
      ) {
        var date = this.formatDate2(list.followup.split("T")[0]);
        var cmTime = new Date(date);
        var dateday = cmTime.getDay();
        if (dateday >= 3) {

          var lastDay = cmTime;
          lastDay.setDate(cmTime.getDate() + 5);
          var today = new Date();
          if (lastDay > today) {
            list.followup2 = 1;
          } else {
            list.followup2 = 0;
          }
        } else {
          var lastDay = cmTime;
          lastDay.setDate(cmTime.getDate() + 3);
          var today = new Date();
          if (lastDay > today) {
            list.followup2 = 1;
          } else {
            list.followup2 = 0;
          }
        }
      }

      if (
        list.followup !== undefined &&
        list.followup !== null &&
        list.followup
      ) {
        list.followup = this.formatDate(list.followup.split("T")[0]);
      }
      let image =
        list.profileimage !== undefined && list.profileimage !== null
          ? list.profileimage.substr(0, 5)
          : "";
      if (image === "https") {
        list.Image = (
          <div
            style={{ cursor: "pointer" }}
            onClick={this.fetchContactDrawerDetails("openDetails", true, list)}
          >
            <img
              src={list.profileimage}
              style={{ borderRadius: "50%", width: "30px" }}
            />
          </div>
        );
      } else if (image !== "https") {
        list.Image = (
          <div
            style={{ cursor: "pointer" }}
            onClick={this.fetchContactDrawerDetails("openDetails", true, list)}
          >
            <img src={Photo} style={{ borderRadius: "50%", width: "30px" }} />
          </div>
        );
      } else {
        list.Image = (
          <div
            style={{ cursor: "pointer" }}
            onClick={this.fetchContactDrawerDetails("openDetails", true, list)}
          >
            <img src={Photo} style={{ borderRadius: "50%", width: "30px" }} />
          </div>
        );
      }

      list.CampaignStatus =
        list.campaignstatus !== null && list.campaignstatus !== undefined
          ? list.campaignstatus === "COMPLETED"
            ? "Completed"
            : list.campaignstatus === "PAUSE"
            ? "Pause"
            : "Live"
          : "";
      if (
        list.connectedon !== undefined &&
        list.connectedon !== null &&
        list.connectedon
      ) {
        list.Connectedon = this.formatDate(list.connectedon);
      }

      if (
        list.notificationdate !== undefined &&
        list.notificationdate !== null &&
        list.notificationdate
      ) {
        list.notificationdate = this.formatDate(
          list.notificationdate
        );
      }

      if (
        list.currentstatus !== undefined &&
        list.currentstatus !== null &&
        list.currentstatus
      ) {
        list.CurrentStage = list.currentstatus;
      }

      if (
        list.currentstatus !== undefined &&
        list.currentstatus !== null &&
        list.currentstatus
      ) {
        if (
          list.invitesent === 0 &&
          (list.currentstatus === "Invite Sent" ||
            list.currentstatus === "Invite Not Sent")
        ) {
          list.CurrentStage = "Invite not Sent";
        } else {
          list.CurrentStage = list.currentstatus;
        }
      }

      if (list.connectedon !== "" && list.connectedon != null) {
        if (
          list.nextstepname !== undefined &&
          list.nextstepname !== null &&
          list.nextstepname
        ) {
          let oldDate = new Date(list.nextstepdate);
          if (list.nextstepdate == "" || list.nextstepdate == null) {
            oldDate = new Date(list.thanksmsgdate);
          }
          var nextDate1 = "";
          let todayDate = new Date();
          let diffTime = todayDate - oldDate;
          let diffDays = diffTime / (1000 * 60 * 60 * 24);
          if (diffDays >= 0) {
            let Planndate = new Date();
            let dd = Planndate.getDate();
            let mm = Planndate.getMonth() + 1;
            let yyyy = Planndate.getFullYear();
            if (dd < 10) {
              dd = "0" + dd;
            }
            if (mm < 10) {
              mm = "0" + mm;
            }
            nextDate1 = `${dd}/${mm}/${yyyy}`;
          } else {
            nextDate1 = list.nextstepdate;
          }
          list.Next_Step = list.nextstepname + " " + this.formatDate(nextDate1);
        }
      }

      if (
        list.nextstepname !== "Send Thanks Message" &&
        list.nextstepname !== "Send Message"
      ) {
        if (
          list.nextstepname !== undefined &&
          list.nextstepname !== null &&
          list.nextstepname
        ) {
          var shownextstepname = "";
          if (list.nextstepname === "Invite Sent") {
            shownextstepname = "Send Invite";
          } else {
            shownextstepname = list.nextstepname;
          }
          list.Next_Step = shownextstepname;
        }
      }

      return null;
    });

    campaignContactsExportData.map(list => {
      if (
        list.lastresponse !== undefined &&
        list.lastresponse !== null &&
        list.lastresponse
      ) {
        list.LR = list.lastresponse;
      }

      if (
        list.notificationdate !== undefined &&
        list.notificationdate !== null &&
        list.notificationdate
      ) {
      
        list.notificationdate = list.notificationdate;
      }


      if (
        list.currentstatus !== undefined &&
        list.currentstatus !== null &&
        list.currentstatus
      ) {
        list.CurrentStage = list.currentstatus;
      }
    });

    const filter = this.filter();
   
    return (
      <div className="CampaignContactsTab">
        <div className="CampaignContactsHeader">
          <div className="CampaignContactsLeftFilters">
   

            <Drawer
              anchor="right"
              open={this.state.openDetails}
              onClose={() => this.closeDetails()}
            >
              <ContactDetails
                onSearchClick={this.onSearchClick}
                refreshMessage1={this.fetchRefresh1}
                refreshMessage={this.fetchRefresh}
                Close={() => this.closeDetails()}
                details={this.state.getData}
                Campaignid={this.state.getCampaignId2}
                Customer={this.state.getCustomer}
                contactStatus={this.state.contactStatus}
                campaignStatus={this.state.campaignStatus}
                id={this.state.contactId}
                tableRerender={this.child.current}
                limit={this.state.limit}
                offset={this.state.offset}
                ContactDetailsWorkflow={this.state.ContactDetailsWorkflow}
                ContactDetailsMessages={this.state.ContactDetailsMessages}
                heading={"Contact Details"}
              />
            </Drawer>

     
            <div className="searchContact triggerFieldBox">
              <div className="campaignStatus">
                <Autocomplete
                  id="country-demo"
                  value={this.state.search2}
                  blurOnSelect={true}
                  onChange={this.handleSearchChange2}
                  options={this.state.search2 ? this.state.options2 : []}
          
                  renderOption={option => (
                    <MenuItem value={option.id}> {option.name}</MenuItem>
                  )}
                  renderInput={params => (
                    <TextField
                      id="outlined-select-currency"
                      {...params}
                      label="Trigger Type"
               
                      variant="outlined"
                      value={null}
                      InputProps={{
                        ...params.InputProps,

                        endAdornment: (
                          <img
                            src={NextArrow}
                            style={{
                              width: "17px",
                              cursor: "pointer"
                            }}
                          />
                        )
                      }}
                      fullWidth
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        ...params.inputProps
                      }}
                    />
                  )}
                />
              </div>

              <TextField
                className="searchFieldBox"
                id="outlined-search"
                label="Search"
                placeholder="Company/name/position/location"
                margin="normal"
                variant="outlined"
                value={this.state.search}
                onChange={this.handleSearchChange}
                onKeyDown={this.onSearchKeyDown}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <img
                      src={SearchIcon}
                      style={{ width: "15px", cursor: "pointer" }}
                      onClick={() => this.onSearchClick()}
                    />
                  )
                }}
              />
            </div>

            <div className="CampaignContactsButton">
              <Button className="button" onClick={this.clearFilters}>
                <span style={{ textTransform: "capitalize" }}> Reset All</span>
              </Button>
            </div>

            {selectedEngagedRow && (
              <ConvertTo
                refresh={() => this.ExportData()}
                target={selectedEngagedRow && selectedEngagedRow.anchorEl}
                contactStatus={selectedEngagedRow.original.contactstatus}
                campaignStatus={selectedEngagedRow.original.campaignstatus}
                id={selectedEngagedRow.original.id}
                clientY={this.state.clientY}
                clientX={this.state.clientX}
                tableRerender={this.child.current}
                onClose={this.onCloseEngagedPopup}
                limit={this.state.limit}
                offset={this.state.offset}
              />
            )}

            <div
              style={{
                marginRight: "0px",
                marginLeft: "auto"
              }}
            >
              <p
                style={{
                  color: "#36454d",
                  fontSize: "15px"
                }}
              >
                Total Records: <span>{this.state.totalCount}</span>
              </p>
            </div>
          </div>
  
        </div>
        <ReactTableComponent
          ref={this.child}
          listData={this.state.campaignContacts}
          listConfig={CampaignContactsListHeaders}
          setData={this.setContactsListData}
          query={campaignContactsTabList2}
          totalCount={this.state.totalCount}
          setLimit={this.SetLimit}
          setOffset={this.SetOffset}
          filter={filter}
          clickToSearch={this.state.clickToSearch}
          onRowClick={this.onTableRowClick}
        />
      </div>
    );
  }
}
export default CampaignContactsTab;





